/** Public site origin (WordPress marketing site + shared domain). */
export const SITE_ORIGIN = 'https://marriagebiodatamaker.app'

/** Next.js biodata tool path on the root domain (avoids WP URL conflicts). */
export const APP_BASE_PATH = '/create'

/**
 * Prefixes app-relative paths with {@link APP_BASE_PATH}.
 * Leaves absolute, blob, and data URLs unchanged.
 */
export function withBasePath(path: string): string {
  if (!path) {
    return path
  }
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('blob:') ||
    path.startsWith('data:')
  ) {
    return path
  }
  if (path === APP_BASE_PATH || path.startsWith(`${APP_BASE_PATH}/`)) {
    return path
  }
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${APP_BASE_PATH}${normalized}`
}

/**
 * Builds the public URL for the biodata creator app.
 *
 * @param locale - Optional locale segment (defaults to English root).
 */
export function getAppUrl(locale?: string): string {
  const localePath = locale && locale !== 'en' ? `/${locale}` : ''
  return `${SITE_ORIGIN}${APP_BASE_PATH}${localePath}`
}
